import { render, staticRenderFns } from "./TvaAccordion.vue?vue&type=template&id=8a900872&scoped=true&"
import script from "./TvaAccordion.vue?vue&type=script&lang=js&"
export * from "./TvaAccordion.vue?vue&type=script&lang=js&"
import style0 from "./TvaAccordion.vue?vue&type=style&index=0&id=8a900872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a900872",
  null
  
)

export default component.exports